import { render } from "./LeaveType.vue?vue&type=template&id=c718f8b0"
import script from "./LeaveType.vue?vue&type=script&lang=js"
export * from "./LeaveType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__